export const OrderInfosKeys = {
  impressions_additional_info: "impressions_additional_info",
};

export type TOrderInfosKeys =
  (typeof OrderInfosKeys)[keyof typeof OrderInfosKeys];
